export const configurton=[
    {
        "role": "superadmin",
        "isUCdOrder":1,
        "business": [
            "4","3","1"
        ],
        "header_tab": [ //opd_c
            "All Orders",
            "Pending Prescription",
            "Un-confirmed Order",
            "Cancelled Orders",
            // "Rejected Orders",
            // "Execute By Vendor",
            "Slot Not Confirmed",
            "Payment Not confirmed",
            "Completed Orders",
            // "Execute By Vendor",
            "Slot Not Confirmed",
            "Payment Not confirmed",
            "Completed Orders",
            "Tests Pending",
            // "Rejected Orders",
            "Reimbursement",
            "Escalation",
            
           
        ],
		"defaultSearchParameters":[
			"AssigneeID",//assaigned_to
        ]
        ,
        "allowedStatus":[

            -1
        ],
        // "header_status": [
           
        //     "All Orders",
        //     "Completed",
        //     "Rejected",
        //     "Tests Pending",
        //     "Prescription Uploaded",
        //     "Prescription Pending",
        // ]

        "header_status": [
            {name:"Un-Confirmed",value:25},
            {name:"Confirmed",value:2},
            {name:"Cancelled",value:8},
            {name:"Customer checked in",value:301},
            {name:"Completed",value:6},
            {name:"All Orders",value:0},
            // {name:"Slot Not Confirmed",value:26},
            // {name:"Report Ready",value:303},
            // {name:"Report Uploaded",value:302},
            // {name:"Prescription Pending",value:1001},
            
             
         ],
        "header_escstatus": [
            {name:"All Orders",value:"allorders"},
            {name:"Un-Confirmed",value:"unconfirmed"},
            {name:"Pending",value:"pending"},
            {name:"Reallocation",value:"reallocation"},
            {name:"To be assigned",value:"tobeassigned"},
            {name:"Completed",value:"completed"},
            {name:"Print Documents",value:"printdocuments"},
            {name:"Reports",value:"reports"},
            {name:"Sample Collection",value:"samplecollection"},
            {name:"Sample Submissions",value:"samplesubmissions"}, 
            {name:"Cancel",value:"cancel"},          
             
         ],
         "header_unconfirmed_status" : [
            {name:"All",value:3},
            {name:"Slot Not Confirmed",value:26},
            {name:"Payment Not Confirmed",value:505},
            ]
        
    },
    {
        "role": "admin",
        "isUCdOrder":1,
        "business": [
            "4","3","1"
        ],
        "header_tab": [
            "All Orders",
            "Pending Prescription",
            "Un-confirmed Order",
            "Cancelled Orders",
            // "Rejected Orders",
            // "Execute By Vendor",
            "Slot Not Confirmed",
            "Payment Not confirmed",
            "Completed Orders",
            // "Execute By Vendor",
            "Slot Not Confirmed",
            "Payment Not confirmed",
            "Completed Orders",
            "Tests Pending",
            // "Rejected Orders",
            "Reimbursement",
            "Escalation",
            
           
        ],
		"defaultSearchParameters":[
			"AssigneeID",//assaigned_to
        ]
        ,
        "allowedStatus":[

            -1
        ],
        "header_escstatus": [
            {name:"All Orders",value:"allorders"},
            {name:"Un-Confirmed",value:"unconfirmed"},
            {name:"Pending",value:"pending"},
            {name:"Reallocation",value:"reallocation"},
            {name:"To be assigned",value:"tobeassigned"},
            {name:"Completed",value:"completed"},
            {name:"Print Documents",value:"printdocuments"},
            {name:"Reports",value:"reports"},
            {name:"Sample Collection",value:"samplecollection"},
            {name:"Sample Submissions",value:"samplesubmissions"}, 
            {name:"Cancel",value:"cancel"},          
             
         ],
         "header_unconfirmed_status" : [
            {name:"All",value:3},
            {name:"Slot Not Confirmed",value:26},
            {name:"Payment Not Confirmed",value:505},
        ]
    },
        {
        "role": "superadmin",
        "isUCdOrder":1,
        "business": [
            "4","3","1"
        ],
        "header_tab": [
            "All Orders",
            "Pending Prescription",
            "Un-confirmed Order",
            "Cancelled Orders",
            // "Rejected Orders",
            // "Execute By Vendor",
            "Slot Not Confirmed",
            "Payment Not confirmed",
            "Completed Orders",
            // "Execute By Vendor",
            "Slot Not Confirmed",
            "Payment Not confirmed",
            "Completed Orders",
            "Tests Pending",
            // "Rejected Orders",
            "Reimbursement",
            "Escalation",
            
           
        ],
		"defaultSearchParameters":[
			"AssigneeID",//assaigned_to
        ]
        ,
        "allowedStatus":[

            -1
        ],
        "header_escstatus": [
            {name:"All Orders",value:"allorders"},
            {name:"Un-Confirmed",value:"unconfirmed"},
            {name:"Pending",value:"pending"},
            {name:"Reallocation",value:"reallocation"},
            {name:"To be assigned",value:"tobeassigned"},
            {name:"Completed",value:"completed"},
            {name:"Print Documents",value:"printdocuments"},
            {name:"Reports",value:"reports"},
            {name:"Sample Collection",value:"samplecollection"},
            {name:"Sample Submissions",value:"samplesubmissions"}, 
            {name:"Cancel",value:"cancel"},          
             
         ],
         "header_unconfirmed_status" : [
            {name:"All",value:3},
            {name:"Slot Not Confirmed",value:26},
            {name:"Payment Not Confirmed",value:505},
            ]
        
    }
];



